import React, { useMemo } from 'react'

import IndexItem from '../../../../../components/pdf/IndexItem'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

import { remapReplies, remapReplyChildren, filterRepliesByQuestionName } from '../../_helpers/pdfHelpers'

const RevisionsSection = ({ serviceOrder }) => {
  const remap = useMemo(() => remapReplyChildren(serviceOrder.replies), [serviceOrder.replies])
  const dinamicPagesLength = useMemo(() => {
    const result = remapReplies(serviceOrder.replies, remap)
    return result.atendimento.length + result.comercial.length
  }, [remap, serviceOrder.replies])

  const temRespostaDeAtendimento = useMemo(() => {
    const replies = filterRepliesByQuestionName(serviceOrder.replies, 'Área de Atendimento')
    const replyFound = replies.find(reply => reply.value)
    return replyFound
  }, [serviceOrder.replies])

  const temRespostaDeComercial = useMemo(() => {
    const replies = filterRepliesByQuestionName(serviceOrder.replies, 'Área Comercial')
    const replyFound = replies.find(reply => reply.value)
    return replyFound
  }, [serviceOrder.replies])

  const riskAssessmentPages = useMemo(() => {
    return temRespostaDeAtendimento && temRespostaDeComercial ? 3 : 0
  }, [temRespostaDeAtendimento, temRespostaDeComercial])

  return (
    <View pageBreakAfter>
      <View pageBreakAfter>
        <Separator weight={15} />
        <Text bold size="small" align="center">
          ÍNDICE
        </Text>
        <Separator weight={8} />
        <IndexItem label="1. IDENTIFICAÇÃO DA EMPRESA" name="1" page={5} />
        <IndexItem label="1.2. IDENTIFICAÇÃO DOS RESPONSÁVEIS PELO PROGRAMA E VISTORIA" name="1" page={5} />
        <IndexItem label="1.3. DESCRIÇÃO DE CARGOS" name="1" page={6} />
        <IndexItem label="2. INTRODUÇÃO" name="2" page={7} />
        <IndexItem label="3. OBJETIVOS" name="3" page={7} />
        <IndexItem label="4. FUNDAMENTAÇÃO LEGAL E TÉCNICA" name="4" page={7} />
        <IndexItem label="5. RESPONSABILIDADES" name="5" page={8} />
        <IndexItem label="5.1 - PELA AGÊNCIA/PROGRAMA" name="5" page={8} />
        <IndexItem label="5.2 - PELA VISTORIA TÉCNICA" name="5" page={8} />
        <IndexItem label="5.3 - FUNCIONÁRIOS DO SANTANDER" name="5" page={8} />
        <IndexItem label="5.4 – PELO SESMT SANTANDER" name="5" page={8} />
        <IndexItem label="5.5 - BANCO SANTANDER" name="5" page={8} />
        <IndexItem label="6. NORMAS E REFERÊNCIAS BIBLIOGRÁFICAS" name="6" page={8} />
        <IndexItem label="7 METODOLOGIA" name="7" page={9} />
        <IndexItem label="7.2. AVALIAÇÃO QUANTITATIVA" name="7" page={9} />
        <IndexItem label="7.2.1 RUÍDO" name="7" page={9} />
        <IndexItem label="7.2.2 ILUMINÂNCIA" name="7" page={9} />
        <IndexItem label="7.2.3 TEMPERATURA E UMIDADE" name="7" page={9} />
        <IndexItem label="7.2.4 VELOCIDADE DO VENTO" name="7" page={9} />
        <IndexItem label="8. EQUIPAMENTOS DE MEDIÇÃO" name="8" page={10} />
        <IndexItem label="9. CONDIÇÕES AMBIENTAIS DE TRABALHO" name="9" page={11} />
        <IndexItem label="9.1. AVALIAÇÃO DE CONFORTO ACÚSTICO" name="9" page={11} />
        <IndexItem label="9.2. AVALIAÇÃO DE NÍVEIS DE TEMPERATURA, UMIDADE E VELOCIDADE DO AR" name="9" page={11} />
        <IndexItem label="9.3. AVALIAÇÃO DE NÍVEIS DE ILUMINAMENTO" name="9" page={11} />
        <IndexItem
          label="10. LEVANTAMENTO, TRANSPORTE, DESCARGA E MOVIMENTOS REPETITIVOS INDIVIDUAL DE MATERIAL"
          name="10"
          page={12}
        />
        <IndexItem label="10.1 LEVANTAMENTO E TRANSPORTE DE CARGA" name="10" page={12} />
        <IndexItem label="10.2 EMPURRAR E PUXAR CARGA" name="10" page={12} />
        <IndexItem label="10.3 MOVIMENTO DE CARGAS LEVES EM ALTA FREQUÊNCIA DE REPETITIVIDADE" name="10" page={12} />
        <IndexItem label="10.3.1 ANÁLISE DAS ATIVIDADES GHE1 / GHE 2 (Tabela 1) – VIDE ANEXOS" name="10" page={12} />
        <IndexItem label="10.3.2 MÉTODO 1 –CHECK LIST DE AVALIAÇÃO DE RISCO" name="10" page={12} />
        <IndexItem label="11. MOBILIÁRIO DOS POSTOS DE TRABALHO" name="11" page={14} />
        <IndexItem label="11.1. ASSENTOS" name="11.1" page={14} />
        <IndexItem label="11.2. MESAS DE TRABALHO" name="11.2" page={14 + dinamicPagesLength + 1} />
        <IndexItem
          label="11.3. MONITORES/ NOTEBOOKS"
          name="11.3"
          page={14 + dinamicPagesLength + dinamicPagesLength + 1}
        />
        <IndexItem label="11.4. TECLADOS" name="11.4" page={14 + dinamicPagesLength + dinamicPagesLength + 1} />
        <IndexItem label="11.5. MOUSES" name="11.5" page={14 + dinamicPagesLength + dinamicPagesLength + 2} />
        <IndexItem
          label="11.6. APOIO PARA OS PÉS"
          name="11.6"
          page={14 + dinamicPagesLength + dinamicPagesLength + 3}
        />
        <IndexItem
          label="11.7. ORGANIZAÇÃO DE TRABALHO"
          name="11.7"
          page={14 + dinamicPagesLength + dinamicPagesLength + 4}
        />
        <IndexItem
          label="12. CONDIÇÕES FÍSICAS DO AMBIENTE DE TRABALHO"
          name="12"
          page={14 + dinamicPagesLength + dinamicPagesLength + 5}
        />
        <IndexItem
          label="12.1. ÁREAS DE CIRCULAÇÃO"
          name="12.1"
          page={14 + dinamicPagesLength + dinamicPagesLength + 5}
        />
        <IndexItem
          label="13. PONTOS DE VERIFICAÇÃO ERGONÔMICA"
          name="13"
          page={14 + dinamicPagesLength + dinamicPagesLength + 5}
        />
        <IndexItem
          label="13.1. ORGANIZAÇÃO DE CABOS"
          name="13.1"
          page={14 + dinamicPagesLength + dinamicPagesLength + 5}
        />
      </View>

      <View>
        <Separator weight={20} />
        <IndexItem
          label="14. DESCRIÇÃO DO CONTINGENTE DE FUNCIONÁRIOS E AVALIAÇÃO DOS RISCOS ERGONÔMICOS"
          name="14"
          page={14 + dinamicPagesLength + dinamicPagesLength + 6}
        />
        <IndexItem
          label="14.1. DESCRIÇÃO DO CONTINGENTE DE FUNCIONÁRIOS"
          name="14.1"
          page={14 + dinamicPagesLength + dinamicPagesLength + 6}
        />
        <IndexItem
          label="14.2. AVALIAÇÃO DOS RISCOS ERGONÔMICOS"
          name="14.2"
          page={14 + dinamicPagesLength + dinamicPagesLength + 6}
        />
        <IndexItem
          label="15. MAPEAMENTO CONCLUSIVO"
          name="15"
          page={14 + dinamicPagesLength + dinamicPagesLength + 10 + riskAssessmentPages}
        />
        <IndexItem
          label="16. ESTABELECIMENTO DE PLANO DE AÇÃO COM METAS, PRIORIDADES E CRONOGRAMA"
          name="16"
          page={14 + dinamicPagesLength + dinamicPagesLength + 10 + riskAssessmentPages}
        />
        <IndexItem
          label="17. CONCLUSÃO"
          name="17"
          page={14 + dinamicPagesLength + dinamicPagesLength + 10 + riskAssessmentPages}
        />
        <IndexItem
          label="18. ASSINATURA"
          name="18"
          page={14 + dinamicPagesLength + dinamicPagesLength + 12 + riskAssessmentPages}
        />
        <IndexItem
          label="ANEXOS"
          name="A"
          page={14 + dinamicPagesLength + dinamicPagesLength + 13 + riskAssessmentPages}
        />
        {/* <IndexItem label="ANEXO A – CERTIFICADO DE CALIBRAÇÃO DO EQUIPAMENTO" name="A" page={5} /> */}
      </View>
      <Separator weight={8} />
    </View>
  )
}

export default RevisionsSection
